import { getPrimaryColor } from '@/configs/theme.ts';

import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { FC, PropsWithChildren, useEffect, useState } from 'react';

import '@mantine/carousel/styles.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import { DatesProvider } from '@mantine/dates';
import '@mantine/dates/styles.css';
import { useLocalStorage } from '@mantine/hooks';
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';

import { themeSettings } from '@/shared/uikit/config/themeSettings/ThemeSettings';
import { NotificationsProvider } from '@/shared/uikit/providers/notifications';

dayjs.locale('ru');

export const RootProvider: FC<PropsWithChildren> = ({ children }) => {
	const [theme, setTheme] = useState({ ...themeSettings, primaryColor: getPrimaryColor() });
	const [primaryColor, setPrimaryColor] = useLocalStorage<string | undefined>({
		key: 'theme',
		defaultValue: getPrimaryColor(),
	});

	useEffect(() => {
		if (primaryColor) {
			setTheme({ ...themeSettings, primaryColor });
		}
	}, [primaryColor]);

	return (
		<MantineProvider theme={theme}>
			<DatesProvider settings={{ locale: 'ru', firstDayOfWeek: 1, weekendDays: [0, 6] }}>
				{children}
				<NotificationsProvider />
			</DatesProvider>
		</MantineProvider>
	);
};
